var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.305 2.829L11.133 0H0v11.133l2.828-2.828V2.83h5.477zM7.695 13.172L4.867 16H16V4.867l-2.828 2.829v5.476H7.695z",
    fill: "#FF4655",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.371 0L0 13.372V16h2.629L16 2.63V0h-2.629z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/_/_/ugg/shared/assets/svg/roles/alt-3/mid.svg";
export { SvgMid as ReactComponent };